var React = require('react');

function Properties12 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M2 1.46482V0H0V2.79815L2 1.46482Z","fill":"currentColor","key":0}),React.createElement("path",{"d":"M0 4V12H4V9H8V12H12V4L6 0L0 4Z","fill":"currentColor","key":1})]);
}

Properties12.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = Properties12;

Properties12.default = Properties12;
